/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';

export default class AchievementCategory extends Model {
	id = Model.attribute('id');
	name = Model.attribute('name');
	description = Model.attribute('description');
	icon = Model.attribute('icon');
	image = Model.attribute('image');
	color = Model.attribute('color');
	order = Model.attribute('order');

	achievements = Model.hasMany('achievements');
}
